export const chooseCmp = {
    title: 'Choose Cmp',
    cmpTitle: 'You can select a theme and country',
    cmpDescription: `In Intelligent Business Analytics, we define the analysis scope and set themes from both business and technical perspectives. For each theme, we have defined a patent search formula based on IPCs and keywords. Simply by selecting a theme, you can analyze the related technology trends. Please utilize the "Explore a THEME" to view all themes included in the system.`,
    searchBtn: 'Analyze the theme',
    leftSelect: 'SELECT a THEME',
    toggleLabel: 'Switch to cross-value chain',
    rightSelect: 'SELECT a COUNTRY',
    leftSelectPlaceholder: 'Please type in English or Japanese',
    leftJump: 'Explore a THEME',
    inputExample: 'Input examples: Solar cell, Big data analysis technology, etc.',
    cate_01: 'Category',
    cate_02: 'Theme Name (EN)',
    cate_03: 'Theme Name (JP)',
    clearAll: 'Clear',
    aiRecommend: 'There are similar themes. Would you like to change the theme?'
}
